module.exports = __webpack_public_path__ + "assets/img/game_3.dc6bb642.png";